/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import logo from '../assets/images/logo.svg'
import bg from '../assets/images/bg.jpg'
import OrnateMountainsR3 from '../assets/images/OrnateMountainsR3.svg'
import ThinnerBrickWireWall1 from '../assets/images/ThinnerBrickWireWall1.svg'
import RivalryCountries from '../assets/images/RivalryCountries.svg'
import PotentialEntrants from '../assets/images/PotentialEntrants-OUT1.svg'
import Substitutes from '../assets/images/Substitutes-OUT1.svg'
import headWind from '../assets/images/headWind.png'
import tailWind from '../assets/images/tailWind.png'
import '../assets/scss/map.scss'
const MedievalMapComponent = () => {
  return (
    <div className="map-wrapper">
      <div className="bgCover">
        <img alt="mapImage" src={logo} className="logo" />
        <img alt="mapImage" src={bg} className="bg" />
        <img alt="mapImage" src={OrnateMountainsR3} className="mountain" />
        <img alt="mapImage" src={ThinnerBrickWireWall1} className="wall" />
        <img alt="mapImage" src={RivalryCountries} className="RivalryCountries" />
        <img alt="mapImage" src={PotentialEntrants} className="PotentialEntrants-OUT1" />
        <img alt="mapImage" src={Substitutes} className="Substitutes-OUT1" />
        <span className="wind head"><img alt="mapImage" src={headWind} /></span>
        <span className="wind tail"><img alt="mapImage" src={tailWind} /></span>
        <ul className="castleMediumList">
          <li className="aggressiveGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="slowGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="aggressiveGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="slowGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="aggressiveGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="slowGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="aggressiveGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="aggressiveGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="slowGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="aggressiveGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="slowGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="aggressiveGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="slowGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="aggressiveGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
        </ul>
        <ul className="castleSmallList">
          <li className="blankScroll">
            <span>Restaurants</span>
          </li>
          <li className="growth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="aggressiveGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="slowGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="aggressiveGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="slowGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="aggressiveGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="slowGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="growth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="slowGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
        </ul>
        <ul className="castleSmallList right">
          <li className="blankScroll">
            <span>Restaurants</span>
          </li>
          <li className="aggressiveGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="aggressiveGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="slowGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="aggressiveGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="slowGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="aggressiveGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
        </ul>
        <ul className="castleBigList">
          <li className="aggressiveGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="classicGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
          <li className="noData">
          </li>
          <li className="aggressiveGrowth">
            <span>AFC Enterprises (AFCE)</span>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default MedievalMapComponent
